<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="4" :offset="18">
                    <el-button type="primary" size="mini" @click="add()" class="header-btn">新建</el-button>
                    <el-button type="success" size="mini" @click="getList()" class="header-btn">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" loading="loading" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="标识" prop="limitId"></el-table-column>
            <el-table-column label="消息通知类型" prop="taskTypeName"></el-table-column>
            <el-table-column label="时间(分钟)" prop="limitTime"></el-table-column>
            <el-table-column label="推送次数" prop="limitNum" ></el-table-column>
            <el-table-column label="消息类型" prop="limitTypeName" ></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="edit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>

                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="设置" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">
                <el-form-item label="消息提醒类型">
                    <el-select v-model="model.taskType"  :disabled="disabledStatus" clearable  placeholder="消息提醒类型">
                        <el-option v-for="item in messageNoticeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="消息类型">
                    <el-select v-model="model.limitType"  :disabled="disabledStatus" clearable  placeholder="消息类型">
                        <el-option v-for="item in messageTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="时间" prop="limitTime">
                    <el-input-number v-model="model.limitTime"  :min="1" :max="9999" placeholder="时间(单位是分钟)"></el-input-number>
                    <span style="color: red">*在设定的时间范围内 单位(分钟)</span>
                </el-form-item>
                <el-form-item label="最多允许接收次数" prop="limitNum">
                    <el-input-number v-model="model.limitNum"  :min="1" :max="99" placeholder="最多允许接收次数"></el-input-number>
                    <span style="color: red">*在设定的时间范围内用户可接收消息次数</span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getMessageLimitListApi, saveMessageLimitApi,deleteMessageLimitApi
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    appId: "",
                    appName: "",
                },
                list: [],
                disabledStatus:false,
                taskTypeList:[{id:1,name:''},{id:2,name:''}],
                messageTypeList:[{id:1,name:'短信'},{id:2,name:'微信模板消息'},{id:3,name:'微信客服消息'},{id:4,name:'邮件'}],
                messageNoticeList:[{id:1,name:'营销类'},{id:2,name:'通知类'}],
                limitTypeList:[],
                model: {
                    limitId: '',
                    taskType: 1,
                    limitTime: 1440,
                    limitNum: 3,
                    limitType: 1
                },
                loading: true,
                recordsTotal: 0,
                rules: {
                    limitTime: [
                        {required: true, message: '请输入时间范围', trigger: 'blur'},
                        {min: 1,max: 400, message: '长度在 1 到 400 个字符', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入模板名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getMessageLimitListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.list = res.data.value;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            add(){
                this.model = {
                    limitId: '',
                    taskType: 1,
                    limitTime: 1440,
                    limitNum: 3,
                    limitType: 1
                };
                this.showDialog = true;
                this.disabledStatus=false;
            },
            edit(row){
                this.model = {
                    limitId:row.limitId,
                    taskType: row.taskType,
                    limitTime: row.limitTime,
                    limitNum: row.limitNum,
                    limitType: row.limitType
                };
                this.showDialog = true;
                this.disabledStatus=true;
            },
            save(){
                this.loading=true;
                //保存
                saveMessageLimitApi(this.model).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteMessageLimitApi({limitId:row.limitId}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/limitMessage.vue